import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../form/TextField';

export const ZipInputComponent = React.forwardRef(({
  value,
  onBlur,
  onChange,
  error,
  errorMessage,
}, ref) => (
  <TextField
    id='in-page-lead-form-zip-input'
    label='U.S. ZIP code'
    ref={ref}
    name='zip'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={onBlur}
    required={true}
    customTheme={'leads'}
    maxLength={5} />
));

ZipInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default ZipInputComponent;
